"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b;
exports.__esModule = true;
exports.generateWorkflowResponseUrl = exports.deleteWorkflowNode = exports.saveWorkflowNode = exports.getWorkflowNodes = exports.deleteWorkflowAgent = exports.updateWorkflowAgent = exports.createWorkflowAgent = exports.getWorkflowAgents = exports.getMultiAgent = exports.deleteMultiAgent = exports.updateMultiAgent = exports.createMultiAgentBot = exports.downloadOrDeleteFile = exports.uploadFileToVertex = exports.getFileData = exports.createCodeExecutorFunction = exports.createCodeNodeAction = exports.syncCatalog = exports.getSyncCatalogStatus = exports.fetchEnvVariables = exports.createNewAction = exports.updateAgent = exports.deleteAction = exports.updateAction = exports.getActionData = exports.getIntentDetectionModels = exports.getVoiceModels = exports.getModels = exports.getActions = exports.getAgents = void 0;
var utils_1 = require("@src/api/utils");
var const_1 = require("@src/const");
// Workflow agents are browser-facing Haptik APIs. Haptik owns the runtime
// integration, so Conversation Studio must not call Call Genie directly.
var HAPTIK_AI_VOICE_BASE_URL = const_1.BASE_URL.replace('/mogambo_api/', '/v1/ai-voice/');
// mogamboRequestV3 only flags a fixed list of status codes as failures, so a
// workflow validation error (422) or a missing record (404) arrives as a
// success carrying an error body. Widening that list would change every other
// screen in the app, so workflow calls resolve it here instead.
var workflowRequest = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    var result, body, failed;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, request];
            case 1:
                result = _d.sent();
                body = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.response) === null || _a === void 0 ? void 0 : _a.body) !== null && _b !== void 0 ? _b : result === null || result === void 0 ? void 0 : result.response) !== null && _c !== void 0 ? _c : {};
                failed = Boolean(body === null || body === void 0 ? void 0 : body.error) || Boolean(body === null || body === void 0 ? void 0 : body.detail);
                return [2 /*return*/, (result === null || result === void 0 ? void 0 : result.success) && failed ? __assign(__assign({}, result), { success: false }) : result];
        }
    });
}); };
var workflowUrl = function (domainId, path) {
    if (path === void 0) { path = ''; }
    return HAPTIK_AI_VOICE_BASE_URL + "domains/" + domainId + "/multiagent/agents" + path;
};
var multiAgentDevBaseUrl = const_1.BASE_URL.replace('/mogambo_api', '') + "call_genie_voice/";
var environment = (_a = process.env.ENV_NAME) === null || _a === void 0 ? void 0 : _a.toLowerCase();
var isStaging = ['stag', 'staging'].includes(environment);
var isProduction = ['prod', 'production'].includes(environment);
var platform = (_b = process.env.PLATFORM) === null || _b === void 0 ? void 0 : _b.toLowerCase();
if (!platform && typeof window !== 'undefined') {
    if (window.location.hostname.includes('jio')) {
        platform = 'jio';
    }
    else if (window.location.hostname.includes('haptik')) {
        platform = 'haptik';
    }
}
var callGenieBaseUrl = process.env.CALL_GENIE_BASE_URL;
var multiAgentBaseUrl = callGenieBaseUrl ||
    (function () {
        if (platform === 'jio') {
            if (isStaging) {
                return 'https://jio-api-appgw.hellohaptik.com/call-genie-voice/';
            }
            if (isProduction) {
                return 'https://jio-api.haptikapi.com/call-genie-voice/';
            }
        }
        else if (platform === 'haptik') {
            // Default to Haptik
            if (isStaging) {
                return 'https://staging.hellohaptik.com/call-genie-voice/';
            }
            if (isProduction) {
                return 'https://api.haptikapi.com/call-genie-voice/';
            }
        }
        // Local/other environments
        return multiAgentDevBaseUrl;
    })();
exports.getAgents = function (domainId, toolType) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/ai_agents/";
    if (Number.isInteger(toolType)) {
        url = const_1.BASE_URL + "domain/" + domainId + "/ai_agents/?tool_id=" + toolType;
    }
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getActions = function (agentId) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/actions/";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getModels = function (domainId) {
    var url = const_1.BASE_URL + "ai_agents/models/?domain_id=" + domainId + "&tool=classic";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getVoiceModels = function () {
    var url = const_1.BASE_URL + "ai_agents/models/?tool=voice";
    return utils_1.mogamboRequestV3(url, 'GET', undefined, undefined, undefined, true);
};
exports.getIntentDetectionModels = function (domainId) {
    var url = const_1.BASE_URL + "ai_agents/models/?domain_id=" + domainId + "&tool=intent_detection";
    return utils_1.mogamboRequestV3(url, 'GET', undefined, undefined, undefined, true);
};
exports.getActionData = function (agentId, action_id) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/" + action_id + "/";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.updateAction = function (agentId, action_id, data) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/" + action_id + "/";
    return utils_1.mogamboRequestV3(url, 'PUT', data);
};
exports.deleteAction = function (agentId, action_id) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/" + action_id + "/?delete=true";
    return utils_1.mogamboRequestV3(url, 'POST');
};
exports.updateAgent = function (domainId, ai_agent, data) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/ai_agent/" + ai_agent + "/";
    return utils_1.mogamboRequestV3(url, 'PUT', data, null, {});
};
exports.createNewAction = function (agentId, data) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/";
    return utils_1.mogamboRequestV3(url, 'POST', data, null);
};
exports.fetchEnvVariables = function (domainId) {
    var url = const_1.BASE_URL + "domain/env_variables/" + domainId + "/";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getSyncCatalogStatus = function (actionId) {
    var url = const_1.BASE_URL + "meta_catalog/" + actionId + "/sync/";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.syncCatalog = function (actionId, data) {
    var url = const_1.BASE_URL + "meta_catalog/" + actionId + "/sync/";
    return utils_1.mogamboRequestV3(url, 'POST', data, null);
};
exports.createCodeNodeAction = function (agentId, data) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/code-node-action/";
    return utils_1.mogamboRequestV3(url, 'POST', data, null);
};
exports.createCodeExecutorFunction = function (data) {
    var url = const_1.BASE_URL + "code_executor/create/";
    return utils_1.mogamboRequestV3(url, 'POST', data, null, undefined, true);
};
exports.getFileData = function (domainId, appId) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/file_manager/?app_id=" + appId + "&use_case=gcp_vertex_rag";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.uploadFileToVertex = function (domainId, appId, actionType, data) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/file_manager/?action_type=" + actionType + "&app_id=" + appId + "&use_case=gcp_vertex_rag";
    return utils_1.mogamboRequestV3(url, 'POST', data, null);
};
exports.downloadOrDeleteFile = function (domainId, appId, actionType, data, fileName) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/file_manager/?action_type=" + actionType + "&app_id=" + encodeURIComponent(appId) + "&use_case=gcp_vertex_rag&file_name=" + encodeURIComponent(fileName);
    return utils_1.mogamboRequestV3(url, 'POST', data, null);
};
// Call Genie Voice Multi Agent APIs
exports.createMultiAgentBot = function (pipecatVoiceId, payload) {
    var url = multiAgentBaseUrl + "contakt-bots/" + pipecatVoiceId + "/agents";
    return utils_1.mogamboRequestV3(url, 'POST', payload, null, undefined, true);
};
exports.updateMultiAgent = function (pipecatVoiceId, agentId, payload) {
    var url = multiAgentBaseUrl + "contakt-bots/" + pipecatVoiceId + "/agents/" + agentId;
    return utils_1.mogamboRequestV3(url, 'PATCH', payload, null, undefined, true);
};
exports.deleteMultiAgent = function (pipecatVoiceId, agentId, payload) {
    var url = multiAgentBaseUrl + "contakt-bots/" + pipecatVoiceId + "/agents/" + agentId + "/delete";
    return utils_1.mogamboRequestV3(url, 'POST', payload, null, undefined, true);
};
exports.getMultiAgent = function (pipecatVoiceId) {
    var url = multiAgentBaseUrl + "contakt-bots/" + pipecatVoiceId + "/agents";
    return utils_1.mogamboRequestV3(url, 'GET', undefined, undefined, undefined, true);
};
exports.getWorkflowAgents = function (domainId) {
    return workflowRequest(utils_1.mogamboRequestV3(workflowUrl(domainId), 'GET', undefined, undefined, undefined, true));
};
exports.createWorkflowAgent = function (domainId, payload) {
    return workflowRequest(utils_1.mogamboRequestV3(workflowUrl(domainId), 'POST', payload, undefined, undefined, true));
};
exports.updateWorkflowAgent = function (domainId, agentId, payload) {
    return workflowRequest(utils_1.mogamboRequestV3(workflowUrl(domainId, "/" + agentId), 'PATCH', payload, undefined, undefined, true));
};
exports.deleteWorkflowAgent = function (domainId, agentId) {
    return workflowRequest(utils_1.mogamboRequestV3(workflowUrl(domainId, "/" + agentId + "/delete"), 'POST', undefined, undefined, undefined, true));
};
exports.getWorkflowNodes = function (domainId, agentId) {
    return workflowRequest(utils_1.mogamboRequestV3(workflowUrl(domainId, "/" + agentId + "/workflow/nodes"), 'GET', undefined, undefined, undefined, true));
};
exports.saveWorkflowNode = function (domainId, agentId, payload) {
    return workflowRequest(utils_1.mogamboRequestV3(workflowUrl(domainId, "/" + agentId + "/workflow/nodes"), 'PUT', payload, undefined, undefined, true));
};
exports.deleteWorkflowNode = function (domainId, agentId, nodeId) {
    return workflowRequest(utils_1.mogamboRequestV3(workflowUrl(domainId, "/" + agentId + "/workflow/nodes/" + nodeId + "/delete"), 'POST', undefined, undefined, undefined, true));
};
exports.generateWorkflowResponseUrl = function (domainId, agentId, payload) {
    return workflowRequest(utils_1.mogamboRequestV3(workflowUrl(domainId, "/" + agentId + "/workflow/response-url"), 'POST', payload, undefined, undefined, true));
};
